import L from "leaflet";

export function createOffsetTopPlaceholders (mapObject) {
    // based on https://stackoverflow.com/a/33621034/
    const mapContainer = mapObject._controlContainer;
    const mapCorners = mapObject._controlCorners;

    mapCorners["offset-topleft"] = L.DomUtil.create("div", "leaflet-offset-topleft", mapContainer)
    mapCorners["offset-topright"] = L.DomUtil.create("div", "leaflet-offset-topright", mapContainer)
}


export function reduceLatLngPrecision (leafletLatlngObject, precision) {
        leafletLatlngObject.lat = parseFloat(leafletLatlngObject.lat.toFixed(precision));
        leafletLatlngObject.lng = parseFloat(leafletLatlngObject.lng.toFixed(precision));

        return leafletLatlngObject;
}